import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

const ConfirmModal = ({ show, title, message, confirmText = "Potvrdit", cancelText = "Zrušit", onConfirm, onCancel, danger = false }) => {
  if (!show) return null;

  return createPortal(
    <div style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9500 }}>
      <div style={{ backgroundColor: "#FFF", borderRadius: "16px", padding: "24px", width: "100%", maxWidth: "420px", margin: "0 16px", boxShadow: "0 20px 25px rgba(0,0,0,0.15)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
          <h3 style={{ fontSize: "18px", fontWeight: 700, margin: 0, color: "#333" }}>{title}</h3>
          <button onClick={onCancel} style={{ padding: "4px", background: "none", border: "none", cursor: "pointer" }}>
            <X size={20} color="#999" />
          </button>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
          <p style={{ color: "#666", margin: 0, fontSize: "14px", lineHeight: "1.5" }}>{message}</p>
        </div>
        <div style={{ display: "flex", gap: "12px" }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: "12px",
              border: "1px solid #E0E0E0",
              borderRadius: "8px",
              backgroundColor: "#FFF",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500,
              color: "#333"
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: "12px",
              backgroundColor: danger ? "#E53935" : "#1976D2",
              color: "#FFF",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: 500
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
